document.addEventListener('alpine:init', () => {
  function productFormQuantitySlider(data = {}) {
    return {
      ...data,

      init() {
        var rangeSliderInstance = rangeSlider(this.$el, {
          value: [this.selectedQuantity, this.min],
          min: this.min,
          max: this.max,
          step: 50,
          thumbsDisabled: [true, false],
          rangeSlideDisabled: true,
          onInput: (value, userInteraction) => {
            if (userInteraction) {
              this.selectedQuantity = value[1];
            };
          }
        });

        this.$watch('selectedQuantity', () => {
          rangeSliderInstance.value([0, this.selectedQuantity || this.min]);
        });
      }
    };
  };

  Alpine.data('productFormQuantitySlider', productFormQuantitySlider);
});
